import React from 'react';

import { useFormikContext } from 'formik';

import RadioButton from 'components/shared/RadioButton/RadioButton';

const options = [
  { label: 'Summary', value: 'summary' },
  { label: 'Detailed', value: 'detailed' }
];

const ExportDataRadio = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export data
      </label>
      <div className="mt-2 flex gap-4">
        {options.map((option) => (
          <RadioButton
            key={option.value}
            dataQA={`radio-export-${option.value}`}
            size="medium"
            isSelected={values.export_data === option.value}
            onChange={() => {
              setFieldValue('export_data', option.value);
              setFieldValue('export_columns', ['all']);
              setFieldValue('selected_columns', []);
            }}
            label={option.label}
            name="export_data"
            wrapperClassName="w-max"
          />
        ))}
      </div>
    </div>
  );
};

export default ExportDataRadio;
